import React from 'react';

export function Input({
  label,
  icon: Icon,
  className = '',
  style: styleProp,
  id,
  ...props
}) {
  const inputId = id || (label ? `input-${label.replace(/\s+/g, '-').toLowerCase()}` : undefined);

  return (
    <div className="space-y-1">
      {label && (
        <label
          htmlFor={inputId}
          className="text-label flex items-center gap-1"
        >
          {label}
        </label>
      )}
      <div className="relative flex items-center">
        {Icon && (
          <span className="absolute left-2.5 pointer-events-none" style={{ color: 'var(--color-text-muted)' }}>
            <Icon size={14} />
          </span>
        )}
        <input
          id={inputId}
          className={`w-full rounded-lg px-3 py-2 text-xs outline-none transition-colors border focus-visible:outline-2 focus-visible:outline-offset-2 ${Icon ? 'pl-8' : ''} ${className}`}
          style={{
            backgroundColor: 'var(--color-bg-primary)',
            borderColor: 'var(--color-border-primary)',
            color: 'var(--color-text-primary)',
            ...styleProp,
          }}
          {...props}
        />
      </div>
    </div>
  );
}
